module.exports = __webpack_public_path__ + "img/Plantare_RENDER_300x300_DX.f058539d.png";